import { FieldType } from '@ngx-formly/material';
import { Subject } from 'rxjs';

import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';

import { ISnDragSlideToggleFormFieldConfig } from '../../interfaces/drag-slide-toggle-form-field-config.interface';
import { ISnDragSlideToggleFieldTemplateOptions } from '../../interfaces/drag-slide-toggle-form-field-template-options.interface';

@Component({
  selector: 'sn-slide-toggle-form-field',
  templateUrl: './drag-slide-toggle.field-type.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnDragSlideToggleFormField
  extends FieldType<ISnDragSlideToggleFormFieldConfig>
  implements OnInit, OnDestroy
{
  public defaultOptions: ISnDragSlideToggleFormFieldConfig = {
    type: 'drag-slide-toggle',
    templateOptions: {
      hideFieldUnderline: true,
    },
  };

  private readonly _destroy$ = new Subject<void>();

  constructor() {
    super();
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  get templateOptions(): ISnDragSlideToggleFieldTemplateOptions {
    return this.field.templateOptions;
  }

  public onToggleChange(event: any): void {
    if (this.templateOptions.change) {
      this.templateOptions.change(this.field, event);
    }
  }
}
